import { connect } from 'react-redux';
import PreviewScreen from '../components/PreviewScreen';
import { getPreviewScreenImgURL } from '../selectors/screen';
import { getScreenStyles } from '../selectors/layout';
function mapStateToProps(state) {
    var _a = getScreenStyles(state, true), imageWidth = _a.imageWidth, imageHeight = _a.imageHeight;
    var imageURL = getPreviewScreenImgURL(state);
    return { imageWidth: imageWidth, imageHeight: imageHeight, imageURL: imageURL };
}
export default connect(mapStateToProps)(PreviewScreen);
